import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';

/** The part of NG-ZORRO's modal service this file changes. */
interface ModalService {
  createOverlay(config: ModalOptions): unknown;
}

/**
 * Gives every modal its gray mask, as NG-ZORRO 16 and 17 did (feature 024, hop 18).
 *
 * About 70 of the portal's modals pass `nzMask: false`. Up to NG-ZORRO 17 the option did not reach the backdrop,
 * which always got the `ant-modal-mask` class, so every user has always seen the mask. NG-ZORRO 18 honors it and
 * those modals opened over the page with no gray background. Only the backdrop class is restored: the rest of the
 * modal still reads `nzMask: false` as before, so clicking outside a modal behaves as it did.
 *
 * Called once before bootstrap. Review it on every NG-ZORRO upgrade: `createOverlay` is not public API.
 */
export function alwaysShowModalMask(prototype: ModalService = NzModalService.prototype as unknown as ModalService): void {
  const createOverlay = prototype.createOverlay;
  prototype.createOverlay = function (this: ModalService, config: ModalOptions) {
    return createOverlay.call(this, { ...config, nzMask: true });
  };
}
